import { Button, Col, Input, Modal, Tabs, Row, Select, Form } from 'antd';
import React, { Dispatch, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'typesafe-actions';

import { CloseOutlined, CarOutlined, EditOutlined } from '@ant-design/icons';
import { ModalTransp, SelectControl, TranspIcon } from './styles';
import {
  clearSelectTransp,
  loadRequestTransp,
  verificarTranspRequest,
} from '../../../../../store/ducks/transportadoras/actions';
import {
  CriaTransportadora,
  EstoqueSelecionarCidade,
  EstoqueSelecionarEstado,
} from '../../../services/estoqueServices';
import { ApplicationState } from '../../../../../store';
import mask, { unmask } from '../../../../../utils/mask';
import { TranspProps } from './props';
import { addItemRequest } from '../../../../../store/ducks/estoqueCart/actions';
import Swal from 'sweetalert2';
import { cnpjValidation } from 'utils/validator';

const ModalTransportadora: React.FC<TranspProps> = ({
  numNota,
  codParceiro,
  codProduto,
  setProps,
  nomeTransportadora,
}) => {
  const loadingtransp = useSelector((state: ApplicationState) => state.Transportadoras.loading);
  const parceiros = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);
  const verificarTransp = useSelector(
    (state: ApplicationState) => state.Transportadoras.verificarTransportadora
  );
  const transpSelecionada = useSelector(
    (state: ApplicationState) => state.Transportadoras.selecionada
  );

  const transportadoras = useSelector((state: ApplicationState) => state.Transportadoras.data);
  const cddAtivo = useSelector((state: ApplicationState) => state.auth.cddAtivo?.codCdd);
  const estoqueCart = useSelector((state: ApplicationState) => state.EstoqueCart.cart);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [radio, setRadio] = useState<any>();
  const [loadingSec, setLoadingSec] = useState<any>();
  const [response, setResponse] = useState<any>();
  const [responseEstado, setResponseEstado] = useState<any>([]);
  const [responseCidade, setResponseCidade] = useState<any>([]);
  const [selectCnpj, setSelectCnpj] = useState<any>();
  const [selectNomeParceiro, setSelectNomeParceiro] = useState<any>();
  // const [result, setResult] = useState<string[]>([]);
  const [nome, setNome] = useState<any>('');
  const [cnpj, setCnpj] = useState<any>('');
  const [estado, setEstado] = useState<any>('');
  const [cidade, setCidade] = useState<any>('');
  const [clienteRetira, setClienteRetira] = useState(false);
  const [control, setControl] = useState(false);
  const opTransp = verificarTransp?.map((transDados) => transDados);
  const dispatch = useDispatch<Dispatch<Action>>();
  const { TabPane } = Tabs;
  const [formatedCNPJ, setFormatedCNPJ] = useState('');

  useEffect(() => {
    dispatch(loadRequestTransp(codParceiro, cddAtivo));
  }, [dispatch, codParceiro, cddAtivo]);

  useEffect(() => {
    setSelectNomeParceiro(
      opTransp?.find(({ nomeParceiro, cnpj }) => (selectCnpj === cnpj ? nomeParceiro : undefined))
    );
  }, [opTransp, selectNomeParceiro, selectCnpj]);

  const stateInicialModal = () => {
    setCnpj(undefined);
    setSelectCnpj(undefined);
    setCidade(undefined);
    setEstado(undefined);
    setNome(undefined);
    setSelectNomeParceiro(undefined);
    dispatch(clearSelectTransp());
    setClienteRetira(false);
    setControl(false);
  };

  const showModal = (codParceiro: any) => {
    setIsModalVisible(true);
    stateInicialModal();
    dispatch(loadRequestTransp(codParceiro, cddAtivo));
    dispatch(verificarTranspRequest());
    setRadio(1);
    setControl(true);

    try {
      setLoadingSec(true);

      EstoqueSelecionarEstado.getEstados().then((res) => {
        setResponseEstado(res?.data.estados);
      });
    } finally {
      setLoadingSec(false);
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setCnpj('');
    setFormatedCNPJ('');
  };

  const handleOk = (values: any) => {
    setProps(values);

    const tSelect = transportadoras.find(
      (eC) =>
        eC.codParceiro === values.TransportadorasCadastradas || values.TransportadorasNaoCadastradas
    );

    const indexcard = estoqueCart?.findIndex(
      (c, indexa) =>
        c.codProduto === codProduto && c.codParceiro === codParceiro && c.numNota === numNota
    );

    if (
      (indexcard !== -1 && indexcard !== undefined && radio === 1) ||
      radio === 3 ||
      (radio === 2 && selectNomeParceiro)
    ) {
      const newEstoque = estoqueCart;
      newEstoque[indexcard] = {
        ...newEstoque[indexcard],
        codTransportadora:
          radio === 3
            ? undefined
            : radio === 1 && values.TransportadorasCadastradas
            ? values.TransportadorasCadastradas
            : radio === 1 && !values.TransportadorasCadastradas
            ? transportPadrao?.codTransportadora
            : radio === 2 && !selectNomeParceiro
            ? response?.codParceiro
            : selectNomeParceiro?.codParceiro,
        nomeTranasportadora:
          radio === 3
            ? 'Cliente retira'
            : radio === 1 && values.TransportadorasCadastradas
            ? tSelect?.nomeParceiro
            : radio === 1 && !values.TransportadorasCadastradas
            ? transportPadrao?.nomeParceiro
            : radio === 2 && !selectNomeParceiro
            ? response?.nome
            : selectNomeParceiro?.nomeParceiro,
        clienteRetira: clienteRetira,
      };
      dispatch(addItemRequest(newEstoque));
    }

    if (radio === 2 && !selectNomeParceiro) {
      const isValidCnpj = cnpjValidation(cnpj);
      if (!isValidCnpj) return;

      try {
        CriaTransportadora.criaTransportadora(parceiros, nome, cnpj, cidade).then((res) => {
          setResponse(res.data);
          setIsModalVisible(false);
          Swal.fire({
            title: 'Transportadora criada com sucesso!',
            html: '',
            icon: 'success',
            showConfirmButton: false,
            timer: 1500,
          }).then((resul) => {
            if (resul) {
              const indexCard = estoqueCart?.findIndex((c, indexa) => c.codProduto === codProduto);

              if (indexCard !== -1 && indexCard !== undefined) {
                const newEstoque2 = estoqueCart;
                newEstoque2[indexCard] = {
                  ...newEstoque2[indexCard],
                  codTransportadora: res.data.codParceiro,
                  nomeTranasportadora: res.data.nome,
                };
                dispatch(addItemRequest(newEstoque2));
              }
            }
          });
        });
      } catch (error) {
        Swal.fire({
          title: 'Não foi possivel criar a transportadora, por favor tente novamente!',
          html: '',
          icon: 'warning',
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } else {
      setIsModalVisible(false);
    }
  };

  const onChange = (e: any) => {
    setRadio(+e);
    +e === 3 ? setClienteRetira(true) : setClienteRetira(false);
  };

  const handleSelectDataChange = (value: any) => {
    setEstado(value);

    try {
      setLoadingSec(true);

      EstoqueSelecionarCidade.getCidades(value).then((res) => {
        setResponseCidade(res?.data.cidades);
      });
    } finally {
      setLoadingSec(false);
    }
  };

  const handleSelectDataChangeCidade = (value: any) => {
    setCidade(value);
  };

  const handleSelectDataChangeControl = (value: any) => {
    value ? setControl(true) : setControl(false);
  };

  // const handleSearch = (value: string) => {
  //   let res: string[] = [];
  //   if (!value || value.indexOf('@') > 0) {
  //     res = [];
  //   } else {
  //     res = opTransp?.map(({ cnpj }) => cnpj);
  //   }
  //   setResult(res);
  // };

  // const onSelect = (value: string) => {
  //   setSelectCnpj(value);
  //   setSelectNomeParceiro(
  //     opTransp?.find(({ nomeParceiro, cnpj }) => (selectCnpj === cnpj ? nomeParceiro : undefined))
  //   );
  //   setControl(true);
  // };

  const handleSetCnpj = (value: string) => {
    setCnpj(unmask(value));
    const onlyNumber = value.replace(/\D/g, '');
    const maskedValue = mask('cpfCnpj', onlyNumber);

    setFormatedCNPJ(maskedValue);
  };

  const { Option } = Select;

  // const OptionComplete = AutoComplete.Option;

  //eslint-disable-next-line
  const transportSelecionada = transportadoras?.map((transpor) => {
    if (transportadoras?.map((tP) => tP.isPadrao === true && transpor.isPadrao === true)) {
      return {
        codTransportadora:
          transportadoras?.find((t) => t.isPadrao === transpor.isPadrao) && transpor?.codParceiro,
        nomeParceiro:
          transportadoras?.find((t) => t.isPadrao === transpor.isPadrao) && transpor?.nomeParceiro,
      };
    }
    if (transportadoras?.map((tPad) => tPad.isPadrao === false && transpor.isPadrao === false)) {
      return {
        codTransportadora:
          transportadoras?.find((tra) => tra.codParceiro === transpor.codParceiro) &&
          transpor?.codParceiro,
        nomeParceiro:
          transportadoras?.find((tra) => tra.codParceiro === transpor.codParceiro) &&
          transpor?.nomeParceiro,
      };
    }
  });

  const transportPadrao = transportSelecionada?.find((tPadrao) => tPadrao);

  const modalSelecionarTransp = (
    <Row gutter={24}>
      <Col md={24} sm={24} xs={24}>
        <Form id="key" name="basic" onFinish={(values) => handleOk(values)}>
          <Form.Item name="selectItem">
            <Tabs defaultActiveKey="1" onChange={onChange}>
              <TabPane tab="Transportadoras cadastradas" key="1">
                <Row>
                  <Col md={24} sm={24} xs={24}>
                    <ModalTransp>
                      <Form.Item name="TransportadorasCadastradas">
                        <SelectControl
                          showSearch
                          // getPopupContainer={(triggerNode: HTMLElement) =>
                          //   triggerNode.parentNode as HTMLElement
                          // }
                          onChange={handleSelectDataChangeControl}
                          onClear={stateInicialModal}
                          onDeselect={stateInicialModal}
                          placeholder={'Selecione uma transportadora'}
                          filterOption={(inputValue, element) =>
                            element?.props.children
                              .toString()
                              .toLowerCase()
                              .replace(/\.|-|\//g, '')
                              .includes(inputValue.replace(/\.|-|\//g, '').toLowerCase())
                          }
                          loading={loadingtransp}
                          value={transpSelecionada?.codParceiro}
                          // defaultValue={transportPadrao?.codTransportadora}
                        >
                          {transportadoras?.map((transp: any) => (
                            <Option value={transp.codParceiro} key={transp.codParceiro}>
                              {transp.nomeParceiro}
                            </Option>
                          ))}
                        </SelectControl>
                      </Form.Item>
                    </ModalTransp>
                  </Col>
                </Row>
              </TabPane>
              <TabPane tab="Nova transportadora" key="2">
                <Row gutter={24}>
                  <Col md={12} sm={24} xs={24}>
                    <ModalTransp>
                      <Form.Item name="TransportadorasNaoCadastradas">
                        {/* <AutoComplete
                          style={{ width: '100%' }}
                          onSearch={handleSearch}
                          placeholder="CNPJ"
                          onClear={stateInicialModal}
                          allowClear={false}
                          autoClearSearchValue={true}
                          onDeselect={stateInicialModal}
                          value={cnpj}
                          onChange={(e) => setCnpj(unmask(e))}
                          onSelect={onSelect}
                          filterOption={(inpValue, org) =>
                            org?.props?.children
                              ?.toString()
                              .replace(/[^\d]/g, '')
                              .toLowerCase()
                              .includes(inpValue?.toLowerCase())
                          }
                        >
                          {result?.map((em: string) => (
                            <OptionComplete key={em} value={em}>
                              {mask('cpfCnpj', em)}
                            </OptionComplete>
                          ))}
                        </AutoComplete> */}
                        <Input
                          style={{ width: '100%' }}
                          placeholder="CNPJ"
                          type="text"
                          value={formatedCNPJ}
                          name="cnpjCpf"
                          onChange={(e) => handleSetCnpj(e.target.value)}
                        />
                      </Form.Item>
                    </ModalTransp>
                  </Col>
                  <Col md={12} sm={24} xs={24}>
                    {!selectCnpj ? (
                      <ModalTransp>
                        <Input
                          style={{ width: '100%' }}
                          placeholder="Nome da transportadora"
                          type="text"
                          value={nome}
                          disabled={!cnpj}
                          name="nome"
                          onChange={(e) => setNome(e.target.value)}
                        />
                      </ModalTransp>
                    ) : (
                      <ModalTransp>
                        <Input
                          value={selectNomeParceiro?.nomeParceiro}
                          type="text"
                          style={{ width: '100%' }}
                          disabled={!cidade}
                        />
                      </ModalTransp>
                    )}
                  </Col>
                  <Col md={12} sm={24} xs={24}>
                    {!selectCnpj ? (
                      <ModalTransp>
                        <SelectControl
                          allowClear
                          style={{ width: '100%' }}
                          key={estado}
                          value={estado}
                          loading={loadingSec}
                          placeholder={'Estado'}
                          disabled={!cnpj}
                          onChange={handleSelectDataChange}
                        >
                          {responseEstado?.map((est: any) => (
                            <Option value={est?.codUf} key={est?.codUf}>
                              {est?.descricao}
                            </Option>
                          ))}
                        </SelectControl>
                      </ModalTransp>
                    ) : (
                      <ModalTransp>
                        <Input
                          style={{ width: '100%' }}
                          value={selectNomeParceiro?.uf}
                          type="text"
                          placeholder="Estado"
                          disabled={!nome}
                        />
                      </ModalTransp>
                    )}
                  </Col>
                  <Col md={12} sm={24} xs={24}>
                    {!selectCnpj ? (
                      <ModalTransp>
                        <SelectControl
                          showSearch
                          // getPopupContainer={(triggerNode: HTMLElement) =>
                          //   triggerNode.parentNode as HTMLElement
                          // }
                          allowClear
                          loading={loadingSec}
                          disabled={!cnpj}
                          style={{ width: '100%' }}
                          key={cidade}
                          placeholder={'Cidade'}
                          onChange={handleSelectDataChangeCidade}
                          filterOption={(inputVal, elemen) =>
                            elemen?.props.children
                              .toString()
                              .toLowerCase()
                              .includes(inputVal?.toLowerCase())
                          }
                          value={cidade}
                        >
                          {responseCidade?.map((c: any) => (
                            <Option value={c.codCid} key={c.codCid}>
                              {c.nome}
                            </Option>
                          ))}
                        </SelectControl>
                      </ModalTransp>
                    ) : (
                      <ModalTransp>
                        <Input
                          style={{ width: '100%' }}
                          value={selectNomeParceiro?.cidade}
                          type="text"
                          disabled={!nome}
                        />
                      </ModalTransp>
                    )}
                  </Col>
                </Row>
              </TabPane>
              <TabPane tab="Cliente retira" key="3">
                <ModalTransp>
                  <p>O cliente vai efetuar a retirada</p>
                </ModalTransp>
              </TabPane>
            </Tabs>
          </Form.Item>
        </Form>
      </Col>
    </Row>
  );

  return (
    <>
      {nomeTransportadora ? (
        <TranspIcon>
          <Button danger type="text" onClick={() => showModal(codParceiro)}>
            <EditOutlined style={{ fontSize: 22 }} />
          </Button>
        </TranspIcon>
      ) : (
        <Button
          type="dashed"
          size="middle"
          onChange={onChange}
          onClick={() => showModal(codParceiro)}
          style={{ borderStyle: 'dashed', borderWidth: 2 }}
          block
        >
          <CarOutlined /> Selecione a transportadora
        </Button>
      )}
      <Modal
        centered
        title="Transportadoras"
        visible={isModalVisible}
        cancelText="Cancelar"
        onCancel={handleCancel}
        maskClosable={false}
        closable={true}
        destroyOnClose={true}
        closeIcon={<CloseOutlined />}
        keyboard={true}
        width={800}
        footer={[
          <Button key="back" type="dashed" size="middle" onClick={handleCancel}>
            Cancelar
          </Button>,
          <Button
            disabled={
              radio === 2 && !cidade && !selectCnpj
                ? !nome || !estado || !cidade || (!cnpj && !selectCnpj)
                : radio === 1 && control === false
                ? !selectNomeParceiro || !transportSelecionada
                : undefined
            }
            form="key"
            onClick={handleOk}
            type="primary"
            htmlType="submit"
          >
            OK
          </Button>,
        ]}
      >
        {modalSelecionarTransp}
      </Modal>
    </>
  );
};

export default ModalTransportadora;
